import React from "react";
import Link from "next/link";
import { Container } from "reactstrap";

import { introductions } from "@/utils/content";
import { routes } from "@/utils/routes";

const Introductions = () => {
  return (
    <Container>
      <div className="intro-text">
        <p>{introductions.en.para1}</p>
        <p>{introductions.en.para2}</p>
        <p>
          {introductions.en.para31}
          <Link href={routes.airmiles}>{introductions.en.link1}</Link>{" "}
          {introductions.en.para32}
        </p>
        <p>
          {introductions.en.para41}
          <Link href={"partners/canpar"}>{introductions.en.link2}</Link>,{" "}
          <Link href={"partners/canada-post"}>{introductions.en.link3}</Link>,{" "}
          <Link href={"partners/ups"}>{introductions.en.link4}</Link>
          {introductions.en.para42}
        </p>
        <p>
          {introductions.en.para51}{" "}
          <Link href={`${routes.connectTools}/shopify`}>
            {introductions.en.link5}
          </Link>{" "}
          &{" "}
          <Link href={`${routes.connectTools}/woocommerce`}>
            {introductions.en.link6}
          </Link>
          {introductions.en.para52}
        </p>
        <p>{introductions.en.para6}</p>
        <p>
          {introductions.en.para71}{" "}
          <Link href={routes.blog}>{introductions.en.link7}</Link>{" "}
          {introductions.en.para72}{" "}
          <Link href={routes.quickVideos}>{introductions.en.link8}</Link>{" "}
          {introductions.en.para73}
        </p>
        <p>{introductions.en.para8}</p>
        <br />
        <p>
          {introductions.en.para9}
          <br />
          {introductions.en.para10}
        </p>
      </div>
    </Container>
  );
};

export default Introductions;
